import { render, staticRenderFns } from "./ModalEmojiPicker.vue?vue&type=template&id=57c93ab8"
import script from "./ModalEmojiPicker.vue?vue&type=script&lang=js"
export * from "./ModalEmojiPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports